/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLocationBaseResponse } from './GetLocationBaseResponse';
import {
    GetLocationBaseResponseFromJSON,
    GetLocationBaseResponseFromJSONTyped,
    GetLocationBaseResponseToJSON,
    GetLocationBaseResponseToJSONTyped,
} from './GetLocationBaseResponse';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
    PaymentTypeToJSONTyped,
} from './PaymentType';
import type { GetClassBaseResponse } from './GetClassBaseResponse';
import {
    GetClassBaseResponseFromJSON,
    GetClassBaseResponseFromJSONTyped,
    GetClassBaseResponseToJSON,
    GetClassBaseResponseToJSONTyped,
} from './GetClassBaseResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetTeacherResponse
 */
export interface GetTeacherResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetTeacherResponse
     */
    teacherId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetTeacherResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof GetTeacherResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof GetTeacherResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof GetTeacherResponse
     */
    preferredName: string | null;
    /**
     * 
     * @type {PaymentType}
     * @memberof GetTeacherResponse
     */
    paymentType: PaymentType;
    /**
     * 
     * @type {number}
     * @memberof GetTeacherResponse
     */
    payRate: number;
    /**
     * 
     * @type {string}
     * @memberof GetTeacherResponse
     */
    biography: string | null;
    /**
     * 
     * @type {any}
     * @memberof GetTeacherResponse
     */
    dateOfBirth: any | null;
    /**
     * 
     * @type {string}
     * @memberof GetTeacherResponse
     */
    cellPhone: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTeacherResponse
     */
    homePhone: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTeacherResponse
     */
    payrollId: string | null;
    /**
     * 
     * @type {any}
     * @memberof GetTeacherResponse
     */
    startDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof GetTeacherResponse
     */
    endDate: any | null;
    /**
     * 
     * @type {string}
     * @memberof GetTeacherResponse
     */
    addressLine1: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTeacherResponse
     */
    addressLine2: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetTeacherResponse
     */
    addressLine3: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeacherResponse
     */
    isInContactUsMailingList: boolean;
    /**
     * 
     * @type {Array<GetLocationBaseResponse>}
     * @memberof GetTeacherResponse
     */
    workLocations: Array<GetLocationBaseResponse>;
    /**
     * 
     * @type {Array<GetClassBaseResponse>}
     * @memberof GetTeacherResponse
     */
    classes: Array<GetClassBaseResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeacherResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeacherResponse
     */
    isFeatured?: boolean;
}



/**
 * Check if a given object implements the GetTeacherResponse interface.
 */
export function instanceOfGetTeacherResponse(value: object): value is GetTeacherResponse {
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('preferredName' in value) || value['preferredName'] === undefined) return false;
    if (!('paymentType' in value) || value['paymentType'] === undefined) return false;
    if (!('payRate' in value) || value['payRate'] === undefined) return false;
    if (!('biography' in value) || value['biography'] === undefined) return false;
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined) return false;
    if (!('cellPhone' in value) || value['cellPhone'] === undefined) return false;
    if (!('homePhone' in value) || value['homePhone'] === undefined) return false;
    if (!('payrollId' in value) || value['payrollId'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('addressLine2' in value) || value['addressLine2'] === undefined) return false;
    if (!('addressLine3' in value) || value['addressLine3'] === undefined) return false;
    if (!('isInContactUsMailingList' in value) || value['isInContactUsMailingList'] === undefined) return false;
    if (!('workLocations' in value) || value['workLocations'] === undefined) return false;
    if (!('classes' in value) || value['classes'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function GetTeacherResponseFromJSON(json: any): GetTeacherResponse {
    return GetTeacherResponseFromJSONTyped(json, false);
}

export function GetTeacherResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTeacherResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'teacherId': ApiUserTasksGetPageParameterFromJSON(json['teacherId']),
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'preferredName': json['preferredName'],
        'paymentType': PaymentTypeFromJSON(json['paymentType']),
        'payRate': json['payRate'],
        'biography': json['biography'],
        'dateOfBirth': json['dateOfBirth'],
        'cellPhone': json['cellPhone'],
        'homePhone': json['homePhone'],
        'payrollId': json['payrollId'],
        'startDate': json['startDate'],
        'endDate': json['endDate'],
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'],
        'addressLine3': json['addressLine3'],
        'isInContactUsMailingList': json['isInContactUsMailingList'],
        'workLocations': ((json['workLocations'] as Array<any>).map(GetLocationBaseResponseFromJSON)),
        'classes': ((json['classes'] as Array<any>).map(GetClassBaseResponseFromJSON)),
        'isActive': json['isActive'],
        'isFeatured': json['isFeatured'] == null ? undefined : json['isFeatured'],
    };
}

export function GetTeacherResponseToJSON(json: any): GetTeacherResponse {
    return GetTeacherResponseToJSONTyped(json, false);
}

export function GetTeacherResponseToJSONTyped(value?: GetTeacherResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teacherId': ApiUserTasksGetPageParameterToJSON(value['teacherId']),
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'preferredName': value['preferredName'],
        'paymentType': PaymentTypeToJSON(value['paymentType']),
        'payRate': value['payRate'],
        'biography': value['biography'],
        'dateOfBirth': value['dateOfBirth'],
        'cellPhone': value['cellPhone'],
        'homePhone': value['homePhone'],
        'payrollId': value['payrollId'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
        'isInContactUsMailingList': value['isInContactUsMailingList'],
        'workLocations': ((value['workLocations'] as Array<any>).map(GetLocationBaseResponseToJSON)),
        'classes': ((value['classes'] as Array<any>).map(GetClassBaseResponseToJSON)),
        'isActive': value['isActive'],
        'isFeatured': value['isFeatured'],
    };
}

